export default __webpack_public_path__ + "static/ay-glossary-havent-found-instagram-b1def1fa03d20a70a58160718da8c223.svg";